import { Injectable } from '@angular/core';
import {Subscription} from 'rxjs';
import {ApiService} from './api.service';
import {SessionStorageService} from './session-storage.service';

@Injectable({
  providedIn: 'root'
})
export class LoanService {

  public companyContextSubscription: Subscription;
  public companyContext: string;

  constructor(private apiService: ApiService, private sessionStorageService: SessionStorageService) {
    this.companyContextSubscription = sessionStorageService.companyChange.subscribe( company => {
      this.companyContext = company;
    });
  }


  public getLoanDetail(loan: string): any {
        if (loan) {
            return this.apiService.get(`/loans/detail/${loan}`);
         }
      }
}
